import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { push } from 'connected-react-router';
import { v4 as uuidv4 } from 'uuid';
import { componentsEnum } from '../../utils/types';

export const restartSession = createAsyncThunk('session/restart', async (_, { dispatch }) => {
  dispatch(push(componentsEnum.properties[componentsEnum.selectArea].route));
});

const createInitialState = () => {
  const uuid = uuidv4();
  return {
    id: uuid,
  };
};

export const session = createSlice({
  name: 'session',
  initialState: createInitialState(),
  reducers: {
  },
  extraReducers: {
    [restartSession().fulfilled]: () => createInitialState(),
  },
});

export const selectSessionId = (state) => state.session.id;

export default session.reducer;
